export const KEYS = {
  ctrlLeft: 'ControlLeft',
  ctrlRight: 'ControlRight',
  altLeft: 'AltLeft',
  altRight: 'AltRight',
  left: 'ArrowLeft',
  right: 'ArrowRight',
  up: 'ArrowUp',
  down: 'ArrowDown',
  del: 'Delete',
  esc: 'Escape',
  ins: 'Insert',
  opt: 'Alt',
  option: 'Alt',
  enter: 'Enter',
  numpadEnter: 'NumpadEnter',
  space: 'Space',
  backSpace: 'Backspace',
  tab: 'Tab',
  i: 'KeyI',
  u: 'KeyU',
  b: 'KeyB',
  x: 'KeyX',
  backquote: 'Backquote',
}

export const IS_MAC_PLATFORM =
  typeof window != 'undefined' && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform)

export enum Modifiers {
  metaKey = 'metaKey',
  ctrlKey = 'ctrlKey',
  shiftKey = 'shiftKey',
}

export const withModKey = (event: KeyboardEvent) => {
  const modKey = IS_MAC_PLATFORM ? Modifiers.metaKey : Modifiers.ctrlKey
  return !!event[modKey]
}

export const withHotKey = (event: KeyboardEvent, key: Modifiers | Modifiers[]): boolean => {
  if (key && typeof key === 'string') {
    return event[key]
  }
  if (key) {
    return Object.keys(key).some((val) => event[val])
  }
  return false
}

export const isEventWithHotKey = (event: KeyboardEvent): boolean => {
  return Object.keys(Modifiers).some((modifier) => event[modifier])
}
